type LocalizedCell = { value?: string; locales?: Record<string, string>; rawData?: unknown };

export const localizedCellValue = (cell: LocalizedCell, locale?: string, showOriginalValue?: boolean) => {
  if (!!locale && !!cell.locales && Object.keys(cell.locales).length && !showOriginalValue) {
    /*
      This (next 3 rows) is a temporary bug fix. All the dates should be shown in swe format.
    */
    if ((cell.rawData as { t?: string } | undefined)?.t === 'd') {
      return cell.locales['sv-SE'] || cell.value;
    }
    return cell.locales[locale] || cell.value;
  }
  return cell.value;
};
